import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ListingPrimeNgModule } from '@modules/my-listings/listing-primeNg.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { ReMultiselectModule } from '../re-multiselect/re-multiselect.module';
import { ApprovelCommentsComponent } from './approvel-comments/approvel-comments.component';
import { HighlightOverlayBubblesComponent } from './highlight-overlay-bubbles/highlight-overlay-bubbles.component';
import { PreviewListingComponent } from './preview-listing/preview-listing.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';

@NgModule({
  declarations: [PreviewListingComponent, ApprovelCommentsComponent, HighlightOverlayBubblesComponent],
  imports: [CommonModule, ListingPrimeNgModule, PipeDirectiveModule, ReMultiselectModule, ReMultipleSelectModule],
  exports: [PreviewListingComponent, ApprovelCommentsComponent, HighlightOverlayBubblesComponent],
})
export class PreviewListingModule {}
